import createRoute  from '@widesk-ui/tools/createRoute';
import InvoiceModel from '@models/account/InvoiceModel';

export default createRoute.table('/invoices', 'account', 'InvoiceTable', InvoiceModel.localize('plural'));